import { MuiModal, Text } from '@pinchenterprisesnpm/friday-ui'
import { RadioGroup } from '@src/features/shift-post-v2/steps/acceptance-criteria-step/components/who-can-work-section/components/radio-group'

const { Header, Content, Footer } = MuiModal

interface IAcceptanceCriteriaModalProps {
  isOpen: boolean
  closeModal: () => void
}

export const AcceptanceCriteriaModal = ({
  isOpen,
  closeModal,
}: IAcceptanceCriteriaModalProps) => {
  return (
    <MuiModal isOpen={isOpen} closeModal={closeModal} fullWidth maxWidth="md">
      <Header title="Edit Acceptance Criteria" />

      <Content>
        <Text px="sm">
          All Upshifters are pre-vetted and have passed background checks.
        </Text>

        <RadioGroup />
      </Content>
    </MuiModal>
  )
}
